import { Navigate, useLocation } from "react-router-dom";
import Helpers from "../Controls/helpers";
import { useSessionShellQuery } from "../../query/useSessionShell";

/** Redirect to dashboard when the user lacks hiring admin roles. */
export function RequireHiring({ children }) {
  const { data, isLoading } = useSessionShellQuery();
  if (isLoading) {
    return <p className="fieldHint">Checking hiring access…</p>;
  }
  const shell = data || {};
  if (!Helpers.canHire(shell)) {
    return <Navigate to="/dashboard" replace />;
  }
  const pending = Helpers.pendingRequiredAgreements(shell);
  if (pending.length > 0) {
    const id = pending[0].AgreementID || pending[0].agreementID;
    return (
      <Navigate
        to={"/agreementSignature/" + id}
        replace
        state={{ returnTo: "/recruit" }}
      />
    );
  }
  return children;
}

/** Redirect to dashboard when the user is not a SysAdmin. */
export function RequireSysAdmin({ children }) {
  const { data, isLoading } = useSessionShellQuery();
  if (isLoading) {
    return <p className="fieldHint">Checking admin access…</p>;
  }
  if (!Helpers.isSysAdmin(data || {})) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

/** Soft gate: if required agreements pending on hiring routes, send to sign. */
export function AgreementHiringGate({ children }) {
  const location = useLocation();
  const { data, isLoading } = useSessionShellQuery();
  if (isLoading) return children;
  const shell = data || {};
  if (
    Helpers.isGatedHiringPath(location.pathname) &&
    !Helpers.isAgreementEscapePath(location.pathname)
  ) {
    const pending = Helpers.pendingRequiredAgreements(shell);
    if (pending.length > 0) {
      const id = pending[0].AgreementID || pending[0].agreementID;
      return (
        <Navigate
          to={"/agreementSignature/" + id}
          replace
          state={{ returnTo: location.pathname }}
        />
      );
    }
  }
  return children;
}
